import { AssignDoctorPanel } from "./AssignDoctorPanel";
import { UnassignDoctorModal } from "./UnassignDoctorModal";
import type { useAssignment } from "../../hooks/useAssignment";

type AssignState = ReturnType<typeof useAssignment>;

export function AssignmentDialogs({ assign }: Readonly<{ assign: AssignState }>) {
  return (
    <>
      <AssignDoctorPanel
        kit={assign.assignTarget}
        mode={assign.assignMode}
        onClose={assign.closeAssign}
        onConfirm={assign.confirmAssign}
      />
      <UnassignDoctorModal
        open={!!assign.unassignTarget}
        onClose={assign.closeUnassign}
        onConfirm={assign.confirmUnassign}
      />
    </>
  );
}
